import {
  type DateRangeOption,
  dateRangeOptions,
} from '~/ui/molecules/DateInput';

/**
 * Narrows an unknown saved-filter value to a supported predefined date range.
 */
export function toPredefinedDateRangeOption(
  value: unknown,
): DateRangeOption | undefined {
  if (typeof value !== 'string') return undefined;

  return Object.hasOwn(dateRangeOptions, value)
    ? (value as DateRangeOption)
    : undefined;
}
